export enum PaymentType {
  Package = 101,
  Order = 106,
  Appointment = 111,
  Subscription = 102,
  PathLabInvoice = 112,
  Campaign = 113,
}

export enum PaymentStatus {
  Paid = 301,
  Pending = 306,
  Failed = 311,
  Refunded = 316,
  Cancelled = 321,
  Disputed = 322,
}
export enum PaymentMethod {
  PAYU = 101,
  EASYBUZZ = 106,
  Cash = 110,
}
